module.exports = __webpack_public_path__ + "static/media/gameboard-a.af9e876e.svg";